"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringDescription = void 0;
const InvalidResult_1 = __importDefault(require("./InvalidResult"));
function stringDescription(details = {}) {
    return Object.assign({ userFacingTitle: 'string', userFacingValue: string => string, validate(value) {
            if (typeof value !== 'string') {
                if (this.allowNonStringValues) {
                    return String(value);
                }
                else {
                    return new InvalidResult_1.default(`Not a string: ${value}`);
                }
            }
            return value;
        } }, details);
}
exports.stringDescription = stringDescription;
